import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";

const AdminSettingsCountDown = ({ onBack, selectedTurnirId }) => {
  const [enabled, setEnabled] = useState(false);
  const [datePart, setDatePart] = useState(""); // Za YYYY-MM-DD
  const [timePart, setTimePart] = useState(""); // Za HH:MM
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });

  // 1. Dohvaćanje trenutnih postavki iz baze za odabrani turnir
  // 1. Dohvaćanje trenutnih postavki iz baze za odabrani turnir
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        if (!selectedTurnirId) {
          setLoading(false);
          return;
        }

        const { data, error } = await supabase
          .from("admin_turniri")
          .select("countdown_enabled, countdown_target")
          .eq("id", selectedTurnirId)
          .maybeSingle();

        if (error) throw error;

        if (data) {
          setEnabled(data.countdown_enabled || false);

          // Razdvajamo timestamp iz baze na datum i vrijeme za zasebne inpute
          if (data.countdown_target) {
            const localDate = new Date(data.countdown_target);

            // Formatira datum u YYYY-MM-DD
            const year = localDate.getFullYear();
            const month = String(localDate.getMonth() + 1).padStart(2, "0");
            const day = String(localDate.getDate()).padStart(2, "0");
            setDatePart(`${year}-${month}-${day}`);

            // Formatira vrijeme u HH:MM
            const hours = String(localDate.getHours()).padStart(2, "0");
            const minutes = String(localDate.getMinutes()).padStart(2, "0");
            setTimePart(`${hours}:${minutes}`);
          }
        }
      } catch (err) {
        console.error("Greška pri dohvaćanju postavki:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, [selectedTurnirId]);

  // 2. Spremanje postavki u bazu za odabrani turnir
  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage({ text: "", type: "" });

    if (enabled && (!datePart || !timePart)) {
      setMessage({
        text: "Molimo odaberite i datum i vrijeme početka turnira.",
        type: "error",
      });
      setSaving(false);
      return;
    }
    if (!selectedTurnirId || selectedTurnirId === "undefined") {
      setMessage({
        text: "Greška: Nije odabran nijedan turnir.",
        type: "error",
      });
      return;
    }

    try {
      // Spajamo datum i vrijeme natrag u jedan ISO string za bazu
      const isoTargetDate =
        enabled && datePart && timePart
          ? new Date(`${datePart}T${timePart}`).toISOString()
          : null;

      const { error } = await supabase
        .from("admin_turniri")
        .update({
          countdown_enabled: enabled,
          countdown_target: isoTargetDate,
        })
        .eq("id", selectedTurnirId);

      if (error) throw error;
      if (onBack) onBack();
      setMessage({
        text: "Postavke odbrojavanja su uspješno spremljene!",
        type: "success",
      });
    } catch (err) {
      console.error("Greška pri spremanju:", err);
      setMessage({
        text: "Došlo je do pogreške prilikom spremanja.",
        type: "error",
      });
    } finally {
      setSaving(false);
    }
  };

  if (loading)
    return (
      <div className="countdown-settings-loader">
        Učitavam postavke odbrojavanja...
      </div>
    );

  return (
    <div className="countdown-settings-wrapper">
      <button className="back-btn" onClick={onBack}>
        <i className="fi fi-rs-arrow-left"></i> Natrag
      </button>
      <div className="countdown-settings-card">
        <div className="countdown-settings-header">
          <h3 className="countdown-settings-title">
            ⏰ Odbrojavanje do turnira
          </h3>
          <p className="countdown-settings-desc">
            Kada je aktivno, odbrojavanje se prikazuje na početnoj stranici ako
            nema utakmica uživo.
          </p>
        </div>

        <form onSubmit={handleSave} className="countdown-settings-form">
          {/* 1. TOGGLE PREKIDAČ */}
          <div className="countdown-settings-toggle-row">
            <label
              htmlFor="cd-toggle"
              className="countdown-settings-label label-bold"
            >
              Aktiviraj odbrojavanje:
            </label>
            <label className="countdown-settings-switch">
              <input
                type="checkbox"
                id="cd-toggle"
                checked={enabled}
                onChange={(e) => setEnabled(e.target.checked)}
              />
              <span className="countdown-settings-slider"></span>
            </label>
          </div>

          {/* Sva polja ispod ovise o tome je li toggle upaljen */}
          <div
            className={`countdown-settings-conditional-fields ${!enabled ? "is-disabled" : ""}`}
          >
            {/* 2. INPUT ZA DATUM */}
            <div className="countdown-settings-group">
              <label htmlFor="cd-date" className="countdown-settings-label">
                Datum početka turnira:
              </label>
              <input
                type="date"
                id="cd-date"
                value={datePart}
                disabled={!enabled}
                onChange={(e) => setDatePart(e.target.value)}
              />
            </div>

            {/* 3. INPUT ZA VRIJEME */}
            <div className="countdown-settings-group">
              <label htmlFor="cd-time" className="countdown-settings-label">
                Vrijeme početka turnira:
              </label>
              <input
                type="time"
                id="cd-time"
                value={timePart}
                disabled={!enabled}
                onChange={(e) => setTimePart(e.target.value)}
              />
            </div>
          </div>

          {/* STATUSNA PORUKA */}
          {message.text && (
            <div className={`countdown-settings-msg ${message.type}`}>
              {message.text}
            </div>
          )}

          {/* 4. GUMB ZA SPREMANJE */}
          <button
            type="submit"
            className="countdown-settings-submit-btn"
            disabled={saving}
          >
            {saving ? "SPREMAM..." : "SPREMI POSTAVKE"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminSettingsCountDown;
